module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auto-edit-table"
  }, [(_vm.title) ? _c('div', {
    staticClass: "with-actions"
  }, [_vm._t("title", [(_vm.title) ? _c('h1', [_vm._v(_vm._s(_vm.title))]) : _vm._e()]), _c('div', {
    staticClass: "ui buttons actions no-print"
  }, [_vm._t("actions"), (_vm.buttonAdd) ? _c('div', {
    staticClass: "ui basic button",
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "add icon themed text inline"
  }), _c('span', {
    staticClass: "themed text"
  }, [_vm._v("新增项目")])]) : _vm._e()], 2)], 2) : _vm._e(), _vm._t("afterTitle"), _c('auto-table', {
    ref: "table",
    attrs: {
      "defines": _vm.defines,
      "unstackable": _vm.unstackable,
      "data": _vm.data,
      "filters": _vm.filters,
      "pagesize": _vm.pagesize,
      "layout": _vm.layout,
      "summary": _vm.summary,
      "sortable": _vm.sortable,
      "detail-view": _vm.detailView,
      "page-reset-on-change": _vm.pageResetOnChange,
      "actions": _vm.actions || "edit"
    },
    on: {
      "action:edit": _vm.edit
    }
  }), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.visible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.$set(_vm.dialog, "visible", $event)
      }
    }
  }, [(_vm.dialog.visible) ? [_vm._t("form", [_c('auto-form', {
    attrs: {
      "defines": _vm.defines,
      "form": _vm.dialog.form,
      "form-type": _vm.dialog.type,
      "meta": _vm.formMeta,
      "title": _vm.dialog.title
    },
    on: {
      "update:form": function($event) {
        _vm.$set(_vm.dialog, "form", $event)
      },
      "submitted": _vm.dialog_close,
      "cancel": _vm.dialog_close
    }
  })], {
    scope: "dialog"
  })] : _vm._e()], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d765cb6","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/auto/AutoEditTable.vue
// module id = 337
// module chunks = 0